import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useKindeAuth } from '@kinde-oss/kinde-auth-react'

import { clearTokenData, setTokenData } from '@/app/slices/authSlice'

export const useAccessToken = () => {
    const { getToken } = useKindeAuth()
    const dispatch = useDispatch()
    const { token, tokenExpireOn } = useSelector((state) => state.auth)

    const acquireToken = useCallback(async () => {
        try {
            const accessToken = await getToken()
            if (accessToken) {
                const tokenParts = accessToken.split('.')
                const payload = JSON.parse(atob(tokenParts[1]))
                const expiresOn = new Date(payload.exp * 1000).toISOString()

                dispatch(
                    setTokenData({
                        token: accessToken,
                        tokenExpireOn: expiresOn,
                    })
                )
            } else {
                dispatch(clearTokenData())
            }
        } catch (error) {
            console.error('Failed to acquire token:', error.message)
            dispatch(clearTokenData())
        }
    }, [getToken, dispatch])

    return {
        token,
        tokenExpireOn,
        acquireToken,
    }
}
